import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-trade-point-brochure.component.scss';
var FormItemTradePointBrochure = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemTradePointBrochure, _super);
    function FormItemTradePointBrochure(element) {
        return _super.call(this, element) || this;
    }
    FormItemTradePointBrochure.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-trade-point-brochure__button');
        this.btnDwnldTradePointBrochure = this.element.querySelector('#downloadTradePointBrochure');
        this.formModal = this.element.closest('.modal.js-apply-now-modal');
        // get button ID to trigger cookie check
        this.btnDisplayTradePointBrochureForm = document.querySelector('a[data-modal="' + this.formModal.id + '"]');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    // check if user has already submitted their details, if they have, display PDF, if not, display form.
    FormItemTradePointBrochure.prototype.checkCurrentUserCookie = function (event) {
        var isCurrentUser = this.getCurrentUserCooke('tradePointBrochureDownload');
        if (isCurrentUser) {
            event.stopImmediatePropagation();
            if (this.formModal && this.btnDwnldTradePointBrochure) {
                this.btnDwnldTradePointBrochure.click();
                this.formModal.classList.add('modal--close');
                this.formModal.classList.add('modal--closed');
                this.showDisplayView("");
            }
            else {
                this.showDisplayView("error");
            }
        }
    };
    FormItemTradePointBrochure.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // check if user has already submitted their details, if they have, display PDF, if not, display form.
        if (this.btnDisplayTradePointBrochureForm) {
            this.btnDisplayTradePointBrochureForm.addEventListener('click', function (event) {
                _this.checkCurrentUserCookie(event);
            });
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemTradePointBrochure.prototype.setCurrentUserCooke = function (cookieName, cookieValue, timeInMinutes) {
        var expires = '';
        if (timeInMinutes) {
            var date = new Date();
            date.setTime(date.getTime() + (timeInMinutes * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = cookieName + '=' + (cookieValue || '') + expires + '; path=/';
    };
    FormItemTradePointBrochure.prototype.getCurrentUserCooke = function (cookieName) {
        var nameEQ = cookieName + '=';
        var cookieInfo = document.cookie.split(';');
        for (var i = 0; i < cookieInfo.length; i++) {
            var cookieInfoItem = cookieInfo[i];
            while (cookieInfoItem.charAt(0) === ' ') {
                cookieInfoItem = cookieInfoItem.substring(1, cookieInfoItem.length);
            }
            if (cookieInfoItem.indexOf(nameEQ) === 0) {
                return cookieInfoItem.substring(nameEQ.length, cookieInfoItem.length);
            }
        }
        return null;
    };
    FormItemTradePointBrochure.prototype.deleteCurrentUserCooke = function (cookieName) {
        document.cookie = cookieName + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    FormItemTradePointBrochure.prototype.submitForm = function (pForm) {
        var _this = this;
        var _recipient = pForm.querySelector("input[name=recipient]");
        var _email = pForm.querySelector("input[name=email]");
        var _subject = pForm.querySelector("input[name=subject]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _postData = {
            'recipient': (_recipient ? _recipient.value : ""),
            'email': (_email ? _email.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'firstname': (_firstname ? _firstname.value : ""),
            'lastname': (_lastName ? _lastName.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : "")
        };
        this.showDisplayView("loader");
        // variables
        var url = '/services/genericform.jsp';
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (response) {
            // Display success - sending email
            _this.analyticsService.dtmFormComplete('complete', response.data);
            if (_this.formModal && _this.btnDwnldTradePointBrochure) {
                // store information for 1 day
                _this.setCurrentUserCooke('tradePointBrochureDownload', 'true', 15);
                _this.btnDwnldTradePointBrochure.click();
                _this.formModal.classList.add('modal--close');
                _this.formModal.classList.add('modal--closed');
                _this.showDisplayView("");
            }
            else {
                _this.showDisplayView("error");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.showDisplayView("error");
        });
    };
    FormItemTradePointBrochure.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemTradePointBrochure;
}(Base));
export { FormItemTradePointBrochure };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-point-brochure/form-item-trade-point-brochure.component.ts
// module id = 978
// module chunks = 0